import CalendarEventsDb from '../schema/CalendarEventsDb';
import { CalendarEvent } from 'mini-calendar-event-types';
import { getItemFromSessionStorage, setItemInSessionStorage } from 'mini-session-storage';

export const DB_NAME = 'calendar-events';

/**
 * Sets the events in store
 * @param val array of events to be stored.
 */
export const setEventsInSessionStorage = (val: CalendarEvent[]) => {
    const now = new Date().toUTCString();
    const sessionStorageData: CalendarEventsDb = {
        lastUpdatedTime: now,
        events: val,
    };
    setItemInSessionStorage(DB_NAME, sessionStorageData);
};

/**
 * Gets all event's in store.
 */
export const getEventsFromSessionStorage = () => {
    const sessionData: CalendarEventsDb = getItemFromSessionStorage(DB_NAME);
    return sessionData?.events;
};

/**
 * Gets the last update time.
 */
export const getLastUpdateTime = () => {
    const sessionData: CalendarEventsDb = getItemFromSessionStorage(DB_NAME);
    return sessionData?.lastUpdatedTime;
};
